import {
    FETCH_USER_DETAILS_REQUEST,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILURE
  
} from '../constants/index';

import { UserApi } from '../api/usersApi'
import { parseJSON } from '../utils/misc';
import { logoutAndRedirect } from './auth';


export function receiveUserData(data) {
    return  {
        type: RECEIVE_USER_DATA,
        payload: {
            data,
        },
    }
}


export function fetchUserRequest() {
    return {
        type: FETCH_USER_REQUEST,
    };
}


export function fetchUsers() {
    return (dispatch) => {
        dispatch(fetchUserRequest());
        AuthApi.getUsers()
            .then(response => {
                dispatch(receiveUserData(response.data));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                }
            });
    };
}


export function receiveUserDetails(data){
    return  {
        type: RECEIVE_USER_DETAILS,
        payload: {
            data,
        },
    }
}



export function fetchUserDetailsRequest() {
    return {
        type: FETCH_USER_DETAILS_REQUEST,
    };
}


export function fetchUserDetailsSuccess(user) {
    delete user.updated_on
    delete user.password
    return {
        type: FETCH_USER_DETAILS_SUCCESS,
        payload: user,
    };
}

export function fetchUserDetailsFailure() {
    return {
        type: FETCH_USER_DETAILS_FAILURE,
    };
}


export function fetchUserDetails(userId){
    return function (dispatch) {
        dispatch(fetchUserDetailsRequest());
        return UserApi.getUserDetails(userId)
        .then(response =>{
            dispatch(fetchUserDetailsSuccess(response.data.user));

        })
        .catch(error => {
            if (error.status === 401) {
                
                dispatch(fetchUserDetailsFailure(error));
            }
            else{
                dispatch(fetchUserDetailsFailure(error));
                console.log(error)
            }
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/user.js